// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__3T3YZ","error":"InputSecondary_error__2IVio","disabled":"InputSecondary_disabled__3rjNC"};